import { renderToStaticMarkup } from 'react-dom/server';
import translationsEN from '../../translations/en.tempedge.json';
import translationsES from '../../translations/es.tempedge.json';
import { MISSING_TRANSLATION } from './translation';

export const LANGUAGES = [
  { name: 'English', code: 'en' },
  { name: 'Spanish', code: 'es' }
];

export const DEFAULT_LANGUAGE_CODE = 'en';

export const BUNDLED_TRANSLATIONS = { en: translationsEN, es: translationsES };

/**
 * Builds the language list and options consumed by the legacy localize provider.
 * The list itself is exported as LANGUAGES so the new translator shares one source of truth.
 * @returns {{languages: Array<{name: string, code: string}>, options: Object}} Legacy provider setup.
 */
export default function defaultLanguages() {
  const onMissingTranslation = () => MISSING_TRANSLATION;

  const options = {
    defaultLanguage: DEFAULT_LANGUAGE_CODE,
    renderToStaticMarkup,
    onMissingTranslation
  };

  return { languages: LANGUAGES, options };
}
